export const AWARDS_AND_PRESS = 'awards-and-press';
export const CONTACT_US = 'contact-us';
export const HOME = 'home';
